<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card id="report-card">
            <loader-barchart
                v-if="isLoading"
                class="graph-overlay"
                style="height: 350px; margin: 2em 0px 2em 20px;"
                :styles="'height: 350px'"
            />
            <div
                id="species-distribution-chart"
                style="height: 350px; margin: 2em 0px 2em 20px;"
            ></div>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot.tooltip";
import "@/jquery/jquery.flot.pie";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import CREPORT from "@/constants/report";
import { forEach, sumBy } from "lodash";
import Axios from "axios";

export default {
    mixins: [Report],
    components: {
        LoaderBarchart: () => import("@/components/elements/loader-barchart"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            title: "Species Distribution",
            dataGraph: {},
            options: {}
        };
    },

    async mounted() {
        let self = this;
        self.data.filterDateOption = false;
        self.data.exportOptionCsvOnly = true;
        self.dynamicPageTitle(self.title);
        self._getSetting().then(() => {
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", this.init);
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.filterDateOption = true;
        this.data.exportOptionCsvOnly = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        async init() {
            let self = this;
            self.isLoading = true;
            self.isError = false;

            await Axios.get(
                `${process.env.BARRAMUNDI}report/patient/distribution_by_species`
            )
                .then(response => {
                    const res = response ? response.data.response : null;
                    if (res && res.message && res.message.code === 200) {
                        self.renderGraph(res.resources.results);
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self.isLoading = false;
                    self.isError = true;
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        renderGraph(results) {
            let self = this;
            const totalSpecies = sumBy(results, "data");
            self.dataGraph = [];
            forEach(results, result => {
                let percentage = (
                    (parseInt(result.data) / totalSpecies) *
                    100
                ).toFixed(2);

                self.dataGraph.push({
                    species: result.label,
                    percentage: percentage + "%",
                    label: `${result.label}: ${result.data} (${percentage} %)`,
                    data: result.data
                });
            });
            self.options = {
                series: {
                    pie: {
                        show: true,
                        radius: 1,
                        label: {
                            show: false,
                            radius: 3 / 4,
                            background: { opacity: 0.5 }
                        }
                    }
                },
                grid: {
                    hoverable: true
                },
                tooltip: true,
                tooltipOpts: {
                    content: "%s",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                },
                legend: { show: true }
            };

            $.plot(
                $("#species-distribution-chart"),
                self.dataGraph,
                self.options
            );
            $(window).resize(function () {
                if (
                    self.$router.history.current.path ==
                    "/report/" + CREPORT.TYPE.SPECIES_DISTRIBUTION
                ) {
                    $.plot(
                        $("#species-distribution-chart"),
                        self.dataGraph,
                        self.options
                    );
                }
            });
        },
        reanderHeaders(dataHeaders) {
            let headers = [];
            forEach(dataHeaders, function (header) {
                headers.push({
                    name: header == "type" ? header.toLowerCase() : header,
                    label: header,
                    field: header == "type" ? header.toLowerCase() : header,
                    align: "left",
                    style: ""
                });
            });
            return headers;
        },
        renderResults(data) {
            let results = [];
            forEach(data, function (result) {
                results.push(result);
            });
            return results;
        }
    }
};
</script>
